<template>
  <div
    class="message-audio-visual"
    :class="{
      'is-self': isSelf
    }"
  >
    <VoicePlayer
      v-if="messageInfo.url"
      :message="messageInfo"
      :options="['download', 'speed']"
      width="auto"
    >
      <template #top="currentMessage">
        <div class="message-audio-visual__duration">
          <i class="icon-phone-line t-iconfont"></i>
          <span class="duration-box">
            <span class="duration-text">通话时长</span>
            <span class="duration-time">{{ currentMessage.message.time }}</span>
          </span>
        </div>
      </template>
    </VoicePlayer>
    <div v-else class="message-text">音频数据拉取失败</div>
  </div>
</template>

<script setup>
import VoicePlayer from '../../voice-player/index.vue'
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      id: '',
      recordUrl: '',
      duration: ''
    })
  },
  isSelf: {
    type: Boolean,
    default: false
  }
})

const formatDuration = (duration) => {
  const totalSeconds = Number(duration) || 0
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const messageInfo = computed(() => {
  return {
    url: props.message.recordUrl,
    time: formatDuration(props.message.duration)
  }
})
</script>

<style lang="scss" scoped>
.message-audio-visual {
  display: inline-flex;

  &.is-self {
    .message-audio-visual__duration {
      flex-direction: row-reverse;

      .t-iconfont {
        margin-right: 0;
        margin-left: 4px;
        // transform: scaleX(-1);
      }

      .duration-box {
        margin-right: 8px;
        margin-left: 0;

        .duration-text {
        }

        .duration-time {
          margin-right: 8px;
          margin-left: 0;
        }
      }
    }
  }

  .message-text {
    padding: 8px 12px;
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    word-break: break-all;
  }

  &__duration {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: #323233;

    .t-iconfont {
      margin-right: 4px;
      font-size: 16px;
      line-height: 1;
    }

    .duration-box {
      flex-grow: 1;
      margin-left: 8px;
      .duration-text {
      }

      .duration-time {
        margin-left: 8px;
      }
    }
  }
}
</style>
